// React
import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
// React

// CSS
import styles from "./UsersDetail.module.css";
// CSS

// Redux
import { useAppDispatch, useAppSelector } from "../../../../app/store";
import {
  getAsyncCandidateUsersForProcessHistory,
  processInstanceHistorySlice,
} from "../../../../Features/ProcessesSlice/ProcessInstanceHistorySlice/processInstanceHistorySlice";
import { ProcessHistoryContext } from "../../../../Contexts/ProcessHistoryContext/ProcessHistoryContext";
import PendingManager from "../../../PendingManager/PendingManager";
import { IsNightModeOnContext } from "../../../../Contexts/IsNightModeOnContext/IsNightModeOnContext";
import Pagination from "../../../../Utils/Pagination/Pagination";
import { I_SingleCandidateUser } from "../../../../Models/interfaces";
import UserDetailModal from "./UserDetailModal/UserDetailModal";
import CustomInput1 from "../../../../Utils/CustomInput1/CustomInput1";
// Redux

type UsersDetailProps = {
  instanceId: string;
  setExtraChild: React.Dispatch<React.SetStateAction<React.ReactElement>>;
};

export type UserModalData = {
  isModalInScreen: boolean;
  modalData: I_SingleCandidateUser;
};

export const initialUserDataModalData: UserModalData = {
  isModalInScreen: false,
  modalData: {
    email: "",
    extraIdentityInformation: {},
    firstname: "",
    lastname: "",
    username: "",
  },
};

const UsersDetail: React.FunctionComponent<UsersDetailProps> = ({
  instanceId,
  setExtraChild,
}) => {
  const dispatch = useAppDispatch();

  const { accessToken: userToken } = useAppSelector((state) => state.loginData);

  const [paginationData, setPaginationData] = useState<{
    page: number;
    size: number;
    search: string;
  }>({
    page: 1,
    search: "",
    size: 5,
  });

  const { selectedHistoryId } = useContext(ProcessHistoryContext);
  const isNightOn = useContext(IsNightModeOnContext);

  const { isDone, data, isError, isPending } = useAppSelector(
    (state) => state.processInstanceHistorySlice.candidateUsers
  );

  const [modalData, setModalData] = useState<UserModalData>(
    initialUserDataModalData
  );

  const memoInput = useMemo(
    () => (
      <>
        <CustomInput1
          defaultValue=""
          inputType="text"
          onBlur={() => {}}
          onChange={(e) => {
            setPaginationData((prevState) => ({
              ...prevState,
              search: e.target.value,
            }));
          }}
          placeHolder="نام کاربر موردنظر را وارد کنید"
          value={paginationData.search}
          dontShowSearchIcon
          placeHolderClassName="text-12"
        />
      </>
    ),
    [paginationData.search]
  );

  const dataGetter = useCallback(() => {
    dispatch(
      getAsyncCandidateUsersForProcessHistory({
        userToken,
        _data: {
          ...paginationData,
          historyId: selectedHistoryId,
          processInstanceId: instanceId,
        },
      })
    );
  }, [dispatch, paginationData, selectedHistoryId, instanceId, userToken]);

  useEffect(() => {
    const timeOut = setTimeout(dataGetter, 500);

    return () => {
      clearTimeout(timeOut);
    };
  }, [dataGetter]);

  useEffect(() => {
    return () => {
      dispatch(processInstanceHistorySlice.actions.resetCandidateUsers());
    };
  }, [dispatch]);

  useEffect(() => {
    setExtraChild(memoInput);
  }, [memoInput, setExtraChild]);

  useEffect(() => {
    return () => {
      setExtraChild(<></>);
    };
  }, [setExtraChild]);

  return (
    <div className={`${styles.usersDetailContainer}  w-100`}>
      {/**  */}
      {modalData.isModalInScreen ? (
        <UserDetailModal modalData={modalData} setModalData={setModalData} />
      ) : null}
      {/**  */}
      <PendingManager
        isDone={isDone}
        isError={isError}
        isPending={isPending}
        onError={dataGetter}
        showAfterDone={
          <>
            <div
              className={`${styles.myTable} ${
                isNightOn ? "nightBg2 pcNight" : ""
              }  w-100 d-flex mt-3 flex-column align-items-center align-items-center`}
            >
              <div
                className={`${styles.tableHead} w-100 d-flex flex-row-reverse align-items-center justify-content-between align-items-center`}
              >
                <p className={`${styles.userName}`}>نام کاربری </p>
                <p className={`${styles.nameAndLastName}`}>
                  نام و نام خانوادگی
                </p>
                <p className={`${styles.email}`}>ایمیل </p>
                <p className={`${styles.extraIdentityData}`}> نمایش </p>
              </div>
              <div
                className={`${styles.tableBody} w-100 d-flex align-items-center flex-column`}
              >
                {data.content.length === 0 ? (
                  <p className="w-100 d-flex flex-row p-0 m-0 mt-2 align-items-center justify-content-center">
                    موردی وجود ندارد
                  </p>
                ) : (
                  <>
                    {data.content.map((item) => (
                      <div
                        key={item.username}
                        className={`${styles.tableData} w-100 d-flex align-items-center justify-content-between align-items-center`}
                      >
                        <div
                          className={`${styles.extraIdentityData} w-max  px-2 rounded-2 d-flex align-items-center justify-content-center`}
                        >
                          <button
                            className="submitBtn px-4 py-1 rounded-2"
                            onClick={() => {
                              setModalData({
                                isModalInScreen: true,
                                modalData: item,
                              });
                            }}
                          >
                            مشاهده
                          </button>
                        </div>
                        <p className={`${styles.email}`}>{item?.email}</p>

                        <p className={`${styles.nameAndLastName}`}>
                          {item.firstname + " " + item.lastname}
                        </p>
                        <p className={`${styles.userName}`}>{item.username}</p>
                      </div>
                    ))}
                  </>
                )}
              </div>
              <div className={`${styles.tableFooter}`}></div>
            </div>
            <Pagination
              dataForPagination={{
                currPage: paginationData.page,
                size: paginationData.size,
                totalPages: data.totalPages,
              }}
              onPageNumberChange={(page) => {
                setPaginationData((prevState) => ({
                  ...prevState,
                  page,
                }));
              }}
              onPageNumbersClick={(page) => {
                setPaginationData((prevState) => ({
                  ...prevState,
                  page,
                }));
              }}
              onPageSizeChange={(size) => {
                setPaginationData((prevState) => ({
                  ...prevState,
                  page: 1,
                  size,
                }));
              }}
              contaienrClassName="w-100"
              search=""
            />
          </>
        }
      />
    </div>
  );
};

export default UsersDetail;
